"use strict";

exports.__esModule = true;
exports.default = consent;

function consent(callback) {
  if (typeof document !== "undefined") {
    document.addEventListener("consentchange", () => {
      callback();
    });
  }
}